/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { IToysrusFooterData } from './toysrus-footer.data';
import { IToysrusFooterProps } from './toysrus-footer.props.autogenerated';

export interface IToysrusFooterViewProps
  extends IToysrusFooterProps<IToysrusFooterData> {
  toysrusFooter: React.ReactNode;
}
export interface IFooterLink {
  linkText?: string;
  linkURL?: string;
}

export interface IFooter extends IFooterLink {
  footerLinkList: IFooterLink[];
  footerHeading?: string;
}

export interface ICssClass {
  classText?: string;
}

/**
 *
 * ToysrusFooter component
 * @extends {React.PureComponent<IToysrusFooterProps<IToysrusFooterData>>}
 */
class ToysrusFooter extends React.PureComponent<
  IToysrusFooterProps<IToysrusFooterData>
> {
  public render(): JSX.Element | null {
    const {
      customerService,
      contactUs,
      aboutText,
      helpText,
      returnExchange,
      jobsText,
      aboutUsText,
      emailSignUp,
      locateStore,
      emailSignUpPageLink,
      locateStorePageLink,
      jobsPageLink,
      aboutUsPageLink,
      returnExchangePageLink,
      helpPageLink,
      contactUsPageLink,
    } = this.props.config;
    const footer: IFooter[] = [
      {
        footerHeading: customerService,
        footerLinkList: [
          {
            linkText: contactUs,
            linkURL: contactUsPageLink,
          },
          {
            linkText: helpText,
            linkURL: helpPageLink,
          },
          {
            linkText: returnExchange,
            linkURL: returnExchangePageLink,
          },
        ],
      },
      {
        footerHeading: aboutText,
        footerLinkList: [
          {
            linkText: aboutUsText,
            linkURL: aboutUsPageLink,
          },
          {
            linkText: jobsText,
            linkURL: jobsPageLink,
          },
        ],
      },
    ];
    const footerNode = (
      <React.Fragment>
        <div className='col-sm-6 col-md-3'>
          <div className='widget hidden-xs-down'>
            <h4 className='footer-headlink '>
              <a href={locateStorePageLink}>{locateStore}</a>
            </h4>
          </div>
          <div className='footertab hidden-sm-up unlink'>
            <label className='footer-headlink'>
              <a href={locateStorePageLink}>{locateStore}</a>
            </label>
          </div>
        </div>
        <div className='col-sm-6 col-md-3'>
          <div className='widget hidden-xs-down'>
            <h4 className='footer-headlink'>
              <a href={emailSignUpPageLink}>{emailSignUp}</a>
            </h4>
          </div>
          <div className='footertab hidden-sm-up unlink'>
            <label className='footer-headlink'>
              <a href='/email-sign-up'>{emailSignUp}</a>
            </label>
          </div>
        </div>
        {footer.map((item, indexP) => (
          <div className='col-sm-6 col-md-3'>
            <div className='widget hidden-xs-down'>
              <h4 className='footer-heading '>{item.footerHeading}</h4>
              <ul className={`widget-list list-unstyled p-0 ul_${indexP}`}>
                {item.footerLinkList.map((p) => (
                  <li>
                    <a href={p.linkURL}>{ReactHtmlParser(p.linkText)}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div className='footertab hidden-sm-up' id={`footertab_${indexP}`}>
              <input
                type='checkbox'
                id={`heading_${indexP}`}
                className='footerinput'
                aria-checked='true'
              />
              <label className='footertab-label' htmlFor={`heading_${indexP}`}>
                {item.footerHeading}
              </label>
              <div className='footertab-content'>
                <ul className={`widget-list list-unstyled p-0 ul_${indexP}`}>
                  {item.footerLinkList.map((p) => (
                    <li>
                      <a href={p.linkURL}>{ReactHtmlParser(p.linkText)}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </React.Fragment>
    );

    const ToysrusFooterProps = {
      ...this.props,
      toysrusFooter: footerNode,
    };
    return this.props.renderView(ToysrusFooterProps);
  }
}

export default ToysrusFooter;
